<template>
  <div :class="'timePickerBox'">
    <div
      class="timePickerBox__header text-center"
      :style="`background-color: ${this.user.config.parameters.parameters.colorprimary}; color: ${this.user.config.parameters.parameters.colorbackground}; border-color: ${this.user.config.parameters.parameters.colorprimary}`"
    >
      {{ $t(title) }}
    </div>
    <v-container class="pickerTime_body px-md-8 py-6">
      <v-row no-gutters v-if="times">
        <PickerTime
          v-for="(time, i) in times"
          :key="i + '-' + time.hours + ':' + time.minutes"
          :time="time"
          :id="i"
          v-on:childToParent="timeClick"
          class="col-3"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue';
import PickerTime from '@/components/fragments/PickerTime.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'TimePicker',
  components: {
    PickerTime
  },
  props: {
    title: String,
    times: Array,
    name: String //TODO: remove key, its probably not needed for functionality after a minor refactor
  },
  methods: {
    timeClick(time, index) {
      this.$emit('timeSelected', time, index);
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
});
</script>

<style scoped lang="scss">
@import './src/assets/scss/_variables.scss';
.timePickerBox {
  // border: 1px solid $gray;
  width: 100%;
  &__header {
    border-radius: 4px 4px 0 0;
    // border-top-left-radius: inherit;
    // border-top-right-radius: inherit;
    border: 1px solid;
    background: $primaryColor;
    color: $lightest;
    padding: 12px 20px;
    letter-spacing: 1.15px;
    border-color: currentColor;
  }
  .pickerTime_body {
    border: #b0b0b0 solid 1px;
    border-radius: 0 0 4px 4px;
  }
}
</style>

<i18n src="../localization/texts.json"></i18n>
